import { render } from "./AntojitosView.vue?vue&type=template&id=a87fe8f4&scoped=true"
import script from "./AntojitosView.vue?vue&type=script&lang=js"
export * from "./AntojitosView.vue?vue&type=script&lang=js"

import "./AntojitosView.vue?vue&type=style&index=0&id=a87fe8f4&scoped=true&lang=css"
import "./AntojitosView.vue?vue&type=style&index=1&id=a87fe8f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87fe8f4"]])

export default __exports__